// Zeiten von–bis: «13:00» bis «18:00» ergibt 5 Stunden (über Mitternacht zählt bis zum nächsten Tag).

/** «13:00», «9:5» oder «1330» → Minuten seit Mitternacht, sonst null */
export function clockMinutes(s: string | null | undefined): number | null {
  const m = String(s ?? "").trim().match(/^(\d{1,2})[:.h]?(\d{2})$/);
  if (!m) return null;
  const h = Number(m[1]);
  const min = Number(m[2]);
  return h < 24 && min < 60 ? h * 60 + min : null;
}

/** Dauer zwischen zwei Uhrzeiten in Minuten; Ende vor Start = über Mitternacht. null bei ungültig oder 0. */
export function spanMinutes(start: string | null | undefined, end: string | null | undefined): number | null {
  const a = clockMinutes(start);
  const b = clockMinutes(end);
  if (a === null || b === null) return null;
  const d = (b - a + 1440) % 1440;
  return d > 0 ? d : null;
}

/** Minuten → «HH:MM» (für MILKEE und Eingabefelder) */
export const clockText = (min: number) => `${String(Math.floor(min / 60) % 24).padStart(2, "0")}:${String(min % 60).padStart(2, "0")}`;
